import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentActor } from 'src/app/models/actors';
import { BuilderRequest } from 'src/app/models/requests';
import { WorkflowStep1Placeholder, WorkflowStep2Placeholder } from 'src/app/models/workflow';

@Component({
  selector: 'app-personlist',
  templateUrl: './personlist.component.html'
})
export class PersonListComponent implements OnInit {
  @Input('placeholders') placeholders?: WorkflowStep2Placeholder[];
  @Input('step1placeholders') step1placeholders?: WorkflowStep1Placeholder[] | undefined; 
  @Input('request') request!: BuilderRequest;
  @Input('showAddMyself') showAddMyself: boolean = false;
  @Input('showMessage') showMessage!: boolean;
  @Input('sortingAllowed') sortingAllowed: boolean = true;
  @Input('allowAddPersons') allowAddPersons?: boolean = false;
  @Output('addMyself') AddMyself = new EventEmitter();
  @Output('addPerson') AddPerson = new EventEmitter();
  @Output('PersonUpdated') personUpdated = new EventEmitter();
  @Output('PersonRemoved') personRemoved = new EventEmitter();
  @Output('PersonChangeOrder') personChangeOrder = new EventEmitter();
  @Output('updatePersonProgress') updatePersonProgress = new EventEmitter();

  draggingDisabled: boolean = true;
  indexChangeOrder: number = 0;
  
  async ngOnInit(): Promise<void> {
    this.request.dossierPersons = this.request.dossierPersons?.sort((a,b) => (a.ordinal < b.ordinal ? -1 : 1))
  }
  
  PersonUpdated(event:any){
    this.personUpdated.emit(event)
  }

  PersonRemoved(event:any){
    if (event.dossierPersonId)
      this.personRemoved.emit(event);
    else
      this.request.dossierPersons.splice(this.request.dossierPersons.indexOf(event), 1);
  }

  deletePlaceholder(event: number) {
    if(this.placeholders && this.placeholders !== null) {
      let placeholderIndex = this.placeholders.findIndex(s => s.placeholderId == event);
      if(placeholderIndex > -1) this.placeholders.splice(placeholderIndex, 1);
    }
    
    this.updatePersonProgress.emit();
  }

  personDropped(event: CdkDragDrop<string[]>){
    this.draggingDisabled = true;
    this.personChangeOrder.emit(event);
  }

  dossierPersonsOrderByOrdinal() {
    return this.request.dossierPersons?.sort((a:DocumentActor, b:DocumentActor) => a.ordinal - b.ordinal);
  }

  dossierPersonsWithoutPlaceholderOrderByOrdinal(){
    let dossierPersonsWithoutPlaceholder = this.getDossierPersonsWithoutPlaceholder();
    return dossierPersonsWithoutPlaceholder?.sort((a:DocumentActor, b:DocumentActor) => a.ordinal - b.ordinal);
  }

  getDossierPersonsWithoutPlaceholder(): DocumentActor[] {
    return this.request.dossierPersons?.filter(person => !this.personHasPlaceholder(person));
  }

  personHasPlaceholder(person: any): boolean {
    return (this.placeholders && this.placeholders?.findIndex(p => p.placeholderId == person.workflowPlaceholderId) >= 0) ?? false;
  }
  
  getDossierPersonByPlaceholderId(placeholderId: number) {
    return this.request.dossierPersons?.find(p => p.workflowPlaceholderId === placeholderId);
  }

  getDossierPersonsByPlaceholderId(placeholderId: number) {
    return this.request.dossierPersons?.filter(p => p.workflowPlaceholderId === placeholderId);
  }

  EnablePersonChangeOrder(event: any) {
    this.indexChangeOrder = event.position - 1;
    this.draggingDisabled = false;
  }

  addPerson(placeholderId?: number) {
    this.AddPerson.emit(placeholderId);
  }

  addMyself(placeholderId?: number) {
    this.AddMyself.emit(placeholderId);
  }

  getPlaceholders() {
    let shownPlaceholders: WorkflowStep2Placeholder[] = [];
    if(this.placeholders){
      let placeholdersObject = {...this.placeholders};
      shownPlaceholders = Object.keys(placeholdersObject).map((index: any) => {
        return placeholdersObject[index];
      });
      let anyOfPlaceholdersRequiredPlaceholders = this.placeholders?.filter(s => s.anyOfPlaceholdersRequired);
      let allOfPlaceholdersRequiredPlaceholders = this.placeholders?.filter(s => s.allOfPlaceholdersRequired);
      anyOfPlaceholdersRequiredPlaceholders.forEach(placeholder => {
        if(!this.request.documentInfo?.some(s => placeholder.anyOfPlaceholdersRequired.includes(s.workflowPlaceholderId!))) shownPlaceholders.splice(shownPlaceholders.findIndex(d => d.placeholderId === placeholder.placeholderId), 1);
      });
      allOfPlaceholdersRequiredPlaceholders.forEach(placeholder => {
        let requiredPlaceholders = placeholder.allOfPlaceholdersRequired;
        let deletePlaceholder: boolean = false;
        requiredPlaceholders.forEach(phId => {
          if(this.request.documentInfo?.findIndex(doc => doc.workflowPlaceholderId === phId) < 0) deletePlaceholder = true;
        });
        if(deletePlaceholder) shownPlaceholders.splice(shownPlaceholders.findIndex(d => d.placeholderId === placeholder.placeholderId), 1);
      });
    }
    return shownPlaceholders.length > 0 ? Array.from(new Set(shownPlaceholders)) : [];
  }

  GetIndexOfPerson(event: string): number {
    let personIndex: number = this.request?.dossierPersons?.sort((n1: any, n2: any) => n1.placeholderId! - n2.placeholderId!).findIndex(s => s.dossierPersonId == event);
    return personIndex;
  }
}
